import { CSSProperties } from 'react';

export const ROLLING_CONTAINER_STYLE: CSSProperties = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  overflow: 'hidden'
};

export const STANDARD_PREVIEW_INDEX_TO_COLLECT = 1;
